import { SnailyPromise } from './SnailyPromise'
import { InvalidOperationError } from './errors/InvalidOperationError'

interface LockItem {
	resolve: () => void
	promise: Promise<void>
}

export function Mutex(): { lock: () => Promise<void>; release: () => void } {
	const queue: LockItem[] = []

	async function lock(): Promise<void> {
		const lockItem: LockItem = {
			resolve: null!,
			promise: null!
		}
		lockItem.promise = new SnailyPromise<void>(function (resolve) {
			lockItem.resolve = resolve
		})
		queue.push(lockItem)

		//if first lock then release it immediately to not block first enter
		if (queue.length === 1) {
			lockItem.resolve()
		}

		return lockItem.promise
	}

	function release(): void {
		if (queue.length === 0) {
			throw new InvalidOperationError('There is not active lock in the queue')
		}

		queue.shift()
		//resolve next lock to let that piece of code be executed
		if (queue.length > 0) {
			queue[0]!.resolve()
		}
	}

	return {
		lock,
		release
	}
}
